<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item label="Area code" prop="areaCode">
                <a-input v-model="queryParam.areaCode" placeholder="Enter area code" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="Country name" prop="country">
                <a-input v-model="queryParam.country" placeholder="Enter country name" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <template v-if="advanced">-->
<!--              <a-col :md="5" :sm="24">-->
<!--                <a-form-item label="是否启用 0-启用 1-禁用" prop="isOpen">-->
<!--                  <a-input v-model="queryParam.isOpen" placeholder="请输入是否启用 0-启用 1-禁用" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--            </template>-->
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />Search</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />Reset</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['mobileCode:mobileCode:add']">
          <a-icon type="plus" />Add
        </a-button>
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['mobileCode:mobileCode:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['mobileCode:mobileCode:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['mobileCode:mobileCode:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>


        <span slot="isOpen" slot-scope="text, record">
          <a-switch checkedChildren="Yes" unCheckedChildren="No" v-model="record.isOpen == 0" @change="changeIsOpen($event,record)"/>
        </span>

        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['mobileCode:mobileCode:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['mobileCode:mobileCode:edit']">
            <a-icon type="edit" />Edit
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['mobileCode:mobileCode:remove']" />-->
<!--          <a @click="handleDelete(record)" v-hasPermi="['mobileCode:mobileCode:remove']">-->
<!--            <a-icon type="delete" />删除-->
<!--          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `Total ${total} items`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageMobileCode,listMobileCode, delMobileCode,changeIsOpen } from '@/api/mobileCode/mobileCode'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'MobileCode',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        areaCode: null,
        country: null,
        isOpen: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'Area code',
          dataIndex: 'areaCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Country name',
          dataIndex: 'country',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Country name (EN)',
          dataIndex: 'countryEn',
          ellipsis: true,
          align: 'center'
        },

        // {
        //   title: '是否启用',
        //   dataIndex: 'isOpen',
        //   scopedSlots: { customRender: 'isOpen' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: 'Actions',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询手机区号列表 */
    getList () {
      this.loading = true
     pageMobileCode(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        areaCode: undefined,
        country: undefined,
        isOpen: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },


    changeIsOpen (e,record) {
      record.isOpen = e ? 0 : 1
      changeIsOpen(record).then(response => {
        this.$message.success(
          'Operation succeeded'
        )
        return  record.isOpen = e ? 0 : 1
      })
    },
    // onShowSizeChange 方法已在 tableMixin 中统一处理，无需重复定义
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: 'Delete selected records?',
        content: 'Selected ID(s): ' + ids,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delMobileCode(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                'Deleted successfully',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: 'Export data?',
        content: 'This will export all data matching current filters, not only selected rows.',
        onOk () {
          that.download('mobileCode/mobileCode/export', {
            ...that.queryParam
          }, `mobile_area_code_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
